import * as React from 'react';
import { accentUtils } from '../../services/HelperService';
import { ConfiguratorContext } from './ConfigContextProvider';
import { fromDecimal, setSizeChanged, useSizeChanged } from './ProductConfiguratorShared';
import { AccentLengthUnbound } from '../unbound/AccentLengthUnbound';




export const ConfigSizeSingle = props => {


    const ctx = React.useContext(ConfiguratorContext);
    const orderLine = ctx.config.OrderLine;

    const controlKey = `ConfigSizeSingle_${props.width}_${ctx.productID}`;
    const changeTag = `ConfigSizeSingle_${ctx.productID}`;

    const sizeChanged = useSizeChanged(accentUtils.getEmptyGuid(), controlKey, changeTag);

    const baseUnit = ctx.config?.Data?.BaseUnit;
    const precision = ctx.config?.Data.ProductPrecision;

    const onChange = React.useCallback(e => {
        const previous = props.width ? orderLine.Width : orderLine.Height;
        if (previous === e || (previous != null && e != null
            && fromDecimal(previous.Value) === fromDecimal(e.Value)
            && Number(previous.Unit) === Number(e.Unit))) return;

        if (props.width) {
            orderLine.Width = e;
        } else {
            orderLine.Height = e;
        }

        // AccentLength already debounces its measured-value changes. Commit and
        // recalculate before notifying pricing: waiting for the whole imperial
        // field to lose focus leaves typed inches out of the saved snapshot.
        setSizeChanged(ctx, changeTag);
        if (ctx.notifyDirty) {
            ctx.notifyDirty();
        }
    }, [ctx, orderLine, props.width, changeTag]);

    const value = props.width ? orderLine.Width : orderLine.Height;

    const key = sizeChanged.changeID;


    return <div className="config-size-single d-flex">
        <div>
            <AccentLengthUnbound
                key={key}
                defaultValue={value}
                defaultUnit={baseUnit}
                precision={ precision}
                onBlur={onChange}
                onChange={onChange}
                required
                disabled={props.readOnly || ctx.isReadOnly}
                min={0}
                invalid={accentUtils.isEmpty(value)}
                // Longer than a typing pause: each committed value runs the full size
                // cascade (hundreds of ms on rule-heavy products), so a per-keystroke
                // debounce priced "7" on the way to "72". onBlur still commits at once.
                debounceMilliseconds={400}
                ariaLabel={props.width ? "Width" : "Height"}
            />
        </div>
    </div>;
};
